<template>
  <main class="stripe-return">
    <section>
      <p class="eyebrow">Stripe · {{ zh ? '测试支付' : 'Test payment' }}</p>
      <h1>{{ title }}</h1>
      <p>{{ description }}</p>
      <nav :aria-label="zh ? '查看支付结果' : 'View payment status'">
        <router-link to="/ucenter/wallet/deposit">{{ zh ? '查看充值记录' : 'Recharge history' }}</router-link>
        <router-link to="/ucenter/staticisp/orders">{{ zh ? '静态代理订单' : 'Static proxy orders' }}</router-link>
        <router-link to="/ucenter/residential/orders">{{ zh ? '动态代理订单' : 'Residential orders' }}</router-link>
      </nav>
      <p class="hint">{{ zh ? '若返回后需要重新登录，请使用付款前的网站地址。localhost 与 127.0.0.1 不共享登录状态。' : 'If sign-in is required, use the same website address as before payment. localhost and 127.0.0.1 do not share sessions.' }}</p>
    </section>
  </main>
</template>

<script>
export default {
  name: 'StripeTestReturn',
  computed: {
    zh() { return String(this.$i18n.locale).toLowerCase().startsWith('zh') },
    cancelled() { return this.$route.path === '/stripe-test-cancel' },
    validSession() {
      const id = this.$route.query.session_id
      return typeof id === 'string' && /^cs_test_[A-Za-z0-9]{1,240}$/.test(id)
    },
    title() {
      if (this.cancelled) return this.zh ? '已返回，支付未完成' : 'Returned from checkout'
      if (!this.validSession) return this.zh ? '支付返回参数无效' : 'Invalid checkout return'
      return this.zh ? '已从支付页面返回' : 'Returned from payment'
    },
    description() {
      if (this.cancelled) return this.zh ? '你已离开支付页面，可在记录中查看状态或重新发起支付。' : 'Check your records before starting another payment.'
      if (!this.validSession) return this.zh ? '请从充值记录或订单列表查看实际支付状态。' : 'Check payment status in your recharge or order history.'
      return this.zh ? '正在等待服务端确认支付结果。返回此页面不代表已到账，请在充值记录或订单列表查看最新状态。' : 'Payment confirmation is handled by the server. This page does not confirm settlement; check your recharge or order history for the latest status.'
    }
  }
}
</script>

<style scoped>
.stripe-return { min-height: 100vh; display: grid; place-items: center; padding: 24px; background: #f5faf9; color: #173f40; }
section { max-width: 680px; padding: 36px; border: 1px solid #d5e9e5; border-radius: 16px; background: white; }
h1 { font-size: 28px; margin: 12px 0 20px; }
p { line-height: 1.7; }
.eyebrow, .hint { color: #627b7c; font-size: 14px; }
nav { display: flex; flex-wrap: wrap; gap: 12px; margin: 28px 0; }
a { padding: 12px 16px; border-radius: 8px; background: #176c67; color: white; text-decoration: none; }
a:focus-visible { outline: 3px solid #ff932c; outline-offset: 3px; }
</style>
